<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-row
      v-if="$route.name !== 'config-tarif-horaire-list'"
      no-gutters
    >
      <v-fade-transition mode="out-in">
        <v-col
          cols="12"
          class="ma-0 pa-0"
        >
          <router-view />
        </v-col>
      </v-fade-transition>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
      >
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12">
              <MainTitle
                title="Tarifs horaire"
                icon="mdi-currency-eur"
                :loading="loading || tarifUpdating"
              >
                <template v-slot:end-of-toolbar>
                  <v-hover>
                    <v-btn
                      v-show="!loading && hasPermission('ROLE_CONFIG_TARIF_HORAIRE_EDIT') && !tarifUpdating"
                      slot-scope="{ hover }"
                      rounded
                      small
                      :color="hover?'green':'black'"
                      @click="showDialogAdd"
                    >
                      <v-icon
                        dark
                        :left="!$vuetify.breakpoint.smAndDown"
                      >
                        mdi-plus-circle-outline
                      </v-icon>
                      <span class="hidden-sm-and-down">Ajouter une catégorie</span>
                    </v-btn>
                  </v-hover>
                </template>
              </MainTitle>
            </v-col>

            <v-col
              v-if="!loading"
              cols="12"
              class="mt-3"
            >
              <v-form
                ref="form"
                lazy-validation
              >
                <v-card v-if="!categories.length">
                  <v-card-text class="text-center grey--text font-italic pa-3">
                    Veuillez créer une catégorie de tarif horaire.
                  </v-card-text>
                </v-card>
                <v-data-table
                  v-if="categories.length"
                  :headers="headers"
                  :items="tarifs"
                  hide-default-header
                  :disable-filtering="true"
                  :disable-sort="true"
                  hide-default-footer
                  class="elevation-1 mb-4"
                  no-data-text="Aucun client trouvé. Veuillez ajouter un client avant de paramétrer les tarifs horaires."
                  item-key="clientId"
                >
                  <template
                    v-if="!$vuetify.breakpoint.xs"
                    v-slot:header="{ props: { headers } }"
                  >
                    <thead>
                      <tr>
                        <th
                          v-for="(header, headerIndex) in headers"
                          :key="headerIndex"
                          :class="headerIndex?'text-center':''"
                        >
                          <span class="subtitle-1 font-weight-black">{{ header.text }}
                            <v-btn
                              v-if="headerIndex && hasPermission('ROLE_CONFIG_TARIF_HORAIRE_EDIT')"
                              class="ma-0 pa-0"
                              small
                              icon
                              @click="showEditCategorie(header.categorieId, header.text, header.code)"
                            ><v-icon small>mdi-pencil</v-icon></v-btn>
                          </span>
                        </th>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:item.libelle="{ item }">
                    {{ item.libelle }}
                  </template>
                  <template
                    v-for="categorie in categories"
                    v-slot:[categorie.categorieField]="{ item }"
                  >
                    <v-row
                      :key="item.clientId+'/'+categorie.categorieId"
                      align="center"
                      justify="center"
                    >
                      <v-text-field
                        v-model="tarifsModel[item.clientId+'/'+categorie.categorieId]"
                        :loading="fieldState[item.clientId+'/'+categorie.categorieId] === 'in-progress'"
                        class="ma-1 right-input"
                        suffix="€/h"
                        outlined
                        dense
                        solo
                        :rules="tarifRules"
                        hide-details
                        type="number"
                        style="max-width: 100px"
                        min="0"
                        @change="saveTarif(item.clientId, categorie.categorieId)"
                      />
                    </v-row>
                  </template>
                </v-data-table>

                <template
                  v-if="$vuetify.breakpoint.xs"
                >
                  <v-col
                    v-for="categorie in categories"
                    :key="categorie.categorieId"
                    cols="12"
                    class="text-center"
                  >
                    <v-btn
                      v-if=" hasPermission('ROLE_CONFIG_TARIF_HORAIRE_EDIT')"
                      class="ma-0"
                      small
                      @click="showEditCategorie(categorie.categorieId, categorie.libelle)"
                    >
                      <v-icon left>
                        mdi-pencil
                      </v-icon>
                      Modifier {{ categorie.libelle }}
                    </v-btn>
                  </v-col>
                </template>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogAdd"
      persistent
      max-width="520"
    >
      <v-card>
        <v-card-title class="headline">
          <span v-if="selectedCategorieId">Modification de la catégorie de tarif horaire</span>
          <span v-else>Ajout d'une catégorie de tarif horaire</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="dialogAddLibelle"
            :disabled="saving"
            class="ma-1"
            autofocus
            label="Catégorie de tarif (Administratif, calculs de TVA...)"
            :rules="[(value) => !!value || 'Libellé obligatoire']"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="saving"
            @click="cancelAddTarif"
          >
            Annuler
          </v-btn>
          <v-btn
            :disabled="!formAddValid || saving"
            :loading="saving"
            @click="confirmAddCategorie"
          >
            <v-icon left>
              mdi-check
            </v-icon>
            <span v-if="selectedCategorieId">Modifier la catégorie</span>
            <span v-else>Ajouter la catégorie</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MainTitle from '../../Common/MainTitle'
import { mask } from 'vue-the-mask'

export default {
  directives: {
    mask
  },
  components: { MainTitle },
  data: () => {
    return {
      selectedCategorieId: null,
      dialogAdd: false,
      dialogAddCode: null,
      dialogAddLibelle: null,
      tarifRules: [
        (value) => {
          let message = 'Format du tarif non valide'
          if ((!value || value === '') && value !== 0 && value !== '0') {
            return message
          }
          if (typeof value === 'number') {
            return true
          }
          value = value.replace(',', '.')
          if (value.match(/^([0-9]*[.])?[0-9]+$/)) {
            return true
          }
          return message
        }
      ]
    }
  },
  computed: {
    ...mapState('worktools/tarifHoraire', ['listTarifsState', 'listTarifsRecords', 'addTarifState', 'tarifsState', 'updateCount']),
    ...mapGetters('user', ['hasPermission']),
    loading () {
      return this.listTarifsState === 'in-progress'
    },
    tarifsModel () {
      if (this.loading) {
        return []
      }
      let result = {}
      this.listTarifsRecords.tarifs.forEach(record => {
        result[record.clientId + '/' + record.categorieId] = record.tarif
      })

      return result
    },
    tarifUpdating () {
      return Object.keys(this.fieldState).filter(id => this.fieldState[id] === 'in-progress').length > 0
    },
    saving () {
      return this.addTarifState === 'in-progress'
    },
    headers () {
      let headers = [
        { text: 'Client', value: 'libelle', sortable: false }
      ]
      this.categories.forEach(categorie => {
        headers.push({ text: categorie.libelle, value: 'categorie-' + categorie.categorieId, sortable: false, align: 'center', categorieId: categorie.categorieId, code: categorie.code })
      })
      return headers
    },
    fieldState () {
      return this.updateCount > -1 ? this.tarifsState : {}
    },
    tarifs () {
      if (this.loading) {
        return []
      }
      return this.listTarifsRecords && this.listTarifsRecords.clients ? this.listTarifsRecords.clients : []
    },
    categories () {
      if (this.loading) {
        return []
      }
      return (this.listTarifsRecords && this.listTarifsRecords.categories ? this.listTarifsRecords.categories : []).map(categorie => ({ ...categorie, categorieField: 'item.categorie-' + categorie.categorieId }))
    },
    formAddValid () {
      if (!this.dialogAddLibelle || this.dialogAddLibelle.trim() === '') {
        return false
      }
      if (this.categories.filter(categorie => {
        return categorie.libelle.trim().toLowerCase() === (this.dialogAddLibelle + '').trim().toLowerCase() && (!this.selectedCategorieId || (this.selectedCategorieId && categorie.categorieId !== this.selectedCategorieId))
      }).length) {
        return false
      }

      return true
    }
  },
  watch: {
    updateCount () {
      setTimeout(() => {
        this.$refs.form && this.$refs.form.validate()
      }, 100)
    }
  },
  mounted () {
    this.listAllTarifs().then(() => {
      setTimeout(() => {
        this.$refs.form && this.$refs.form.validate()
      }, 500)
    })
  },
  methods: {
    ...mapActions('worktools/tarifHoraire', ['listAllTarifs', 'addCategorie', 'setTarif', 'editCategorie']),
    cancelAddTarif () {
      this.selectedCategorieId = null
      this.dialogAddLibelle = null
      this.dialogAdd = false
      this.dialogAddCode = null
    },
    confirmAddCategorie () {
      if (this.selectedCategorieId) {
        return this.editCategorie({
          categorieId: this.selectedCategorieId,
          libelle: this.dialogAddLibelle,
          code: this.dialogAddCode
        }
        )
          .then(() => {
            this.selectedCategorieId = null
            this.dialogAdd = false
          })
      }
      return this.addCategorie({
        libelle: this.dialogAddLibelle,
        code: this.dialogAddCode
      }
      )
        .then(() => {
          this.dialogAdd = false
        })
    },
    showDialogAdd () {
      this.dialogAddLibelle = null
      this.dialogAddCode = null
      this.dialogAdd = true
    },
    saveTarif (clientId, categorieId) {
      let value = this.tarifsModel[clientId + '/' + categorieId]
      if (this.tarifRules.filter(rule => rule(value) !== true).length) {
        value = null
      }
      this.setTarif({
        clientId,
        categorieId,
        tarif: value === null ? null : parseFloat(value.replace(',', '.'))
      })
    },
    showEditCategorie (categorieId, libelle, code) {
      this.selectedCategorieId = categorieId
      this.dialogAddLibelle = libelle
      this.dialogAddCode = code
      this.dialogAdd = true
    }
  }
}
</script>
<style>
  .right-input input {
    text-align: right
  }

  /* Chrome, Safari, Edge, Opera */
  .right-input input::-webkit-outer-spin-button,
  .right-input input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  .right-input input[type=number] {
    -moz-appearance:textfield;
  }
</style>
